// extracted by mini-css-extract-plugin
module.exports = {"container":"e_rx","icon":"e_sx"};